import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStudioDisplay: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="studio-display, thunderbolt"><path fillRule="evenodd" clipRule="evenodd" d="M2 7.75C2 5.67893 3.67893 4 5.75 4H18.25C20.3211 4 22 5.67893 22 7.75V14.25C22 16.3211 20.3211 18 18.25 18H16V20.25C16 20.6642 15.6642 21 15.25 21H8.75C8.33579 21 8 20.6642 8 20.25V18H5.75C3.67893 18 2 16.3211 2 14.25V7.75ZM9.5 18V19.5H14.5V18H9.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconStudioDisplay;
